
import { Vue, Component } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'

import useragent from '@finance/useragent'
import {
  collectInit,
  trackLeavePage,
  PAGE_NAME,
  // OPRATION_POPUP_CODE,
  // actLogin
} from '@/utils/common'
import { closeWebViewBounce, loadRewardVideoAd } from '@/utils/client'
import requestBackActionNotify from '@common/client/src/requestBackActionNotify'
import closeView from '@common/client/src/closeView'
import {
  showVideoAd,
  doneVideoAd
} from '@/services/index'
import defaultLogo from '@/assets/img/logo.png'
import CommonHeader from '../components/CommonHeader.vue'

const actModule = namespace('act')

@Component({
  name: 'home',
  components: {
    CommonHeader
  },
})
export default class Index extends Vue {
  // @Getter('userInfo') userInfo!: any
  @State((state) => state.common.profile) profile!: any
  @Getter('phoneInfo') phoneInfo!: any
  @actModule.Getter adInfo!: any
  @actModule.Action bootstrap!: any
  @actModule.Action getAdInfo!: any

  get userLogo() {
    return this.profile?.avatarUrl || defaultLogo
  }
  get deviceUUID() {
    return this.phoneInfo?.UUID || ' --'
  }

  btnQuit = false
  adTrace = ''

  trackTimeStart() {
    window._pageTimeOp = new Date().getTime()
  }
  backTrack() {
    this.$Collect.trackEvent(`${PAGE_NAME}_返回`)
    this.btnQuit = true
    trackLeavePage(PAGE_NAME)
    closeView()
  }
  async handleVideoClick() {
    if (this.adInfo.complete) {
      this.$sui.toast('今日观看次数已用完，明日再来吧!')
      this.$Collect.trackEvent(`${PAGE_NAME}_用户无观看次数`)
      return
    }
    await this.getAdInfo()
    if (this.adInfo.NoQuota) {
      this.$sui.toast('今日观看名额已抢完，明日再来吧!')
      this.$Collect.trackEvent(`${PAGE_NAME}_用户无观看名额`)
      return
    }

    const result = await showVideoAd(this.deviceUUID)
    this.adTrace = result?.data?.trace
    loadRewardVideoAd({
      platform: this.adInfo.platform,
      codeBitId: this.adInfo.codeBitId,
      mediaExtra: JSON.stringify({
        deviceUUID: this.deviceUUID,
        adTrace: this.adTrace,
      })
    }).then((res: any) => {
      console.log('H5-done2', res)
      const { adInfo, loadParams, rewardSuccess } = res || {}
      const { deviceUUID, adTrace } = JSON.parse(loadParams.mediaExtra)
      this.$Collect.trackEvent(`${PAGE_NAME}_成功唤起激励视频`)
      if (!rewardSuccess) {
        return
      }
      this.$Collect.trackView(`${PAGE_NAME}_获得奖励`)
      doneVideoAd({
        key: deviceUUID,
        trace: adTrace,
        reward: rewardSuccess,
        ad_info: JSON.stringify(adInfo)
      }).then(() => {
        !!this && this.init()
      })
    }).catch(() => {
      this.$Collect.trackEvent(`${PAGE_NAME}_唤起激励视频失败`)
    })
  }
  async init() {
    this.trackTimeStart()
    await this.bootstrap({ force: true })
    if (this.adInfo.complete) {
      this.$sui.toast('今日观看次数已用完，明日再来吧!')
      return
    }
    if (this.adInfo.NoQuota) {
      this.$sui.toast('今日观看名额已抢完，明日再来吧!')
    }
  }
  async visibilitychange() {
    if (document.visibilityState === 'visible') {
      this.init()
    } else {
      !this.btnQuit && trackLeavePage(PAGE_NAME)
    }
  }
  async mounted() {
    await this.$store.dispatch('getClientInfo')
    await this.init()
    await collectInit({ pageName: PAGE_NAME })
    this.$Collect.trackView(`${PAGE_NAME}_浏览`)
    document.addEventListener('visibilitychange', this.visibilitychange)

    if (useragent.isSuishouji) {
      requestBackActionNotify(this.backTrack)
    } else if (useragent.isKaniu) {
      window.onClickCloseBtn = window.onClickReturnBtn = this.backTrack
    }

    if (useragent.isIOS && useragent.isSuishouji) {
      closeWebViewBounce()
    }
    // setTimeout(() => {
    //   window.isPayingOrderNo = '1111111111111111'
    //   h5PayOrderPoller.call(this)
    // }, 1000)
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    document.removeEventListener('visibilitychange', this.visibilitychange)
    next()
  }
}
